import styled from 'styled-components';

export const Container = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background: #F5F5F5;
  min-height: 100vh;
  padding-bottom: 100px;
  position: relative;
`;

export const Header = styled.div`
  position: relative;
  background: white;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #E5E5E5;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0;
`;

export const Content = styled.div`
  padding: 20px;
`;

export const FacilityCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const FacilityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const FacilityInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const FacilityName = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

export const FacilityLocation = styled.div`
  font-size: 15px;
  color: #999;
`;

export const SeatCount = styled.div`
  font-size: 14px;
  color: #666;
  font-weight: 500;
  text-align: right;
  margin-bottom: 6px;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 12px;
  background: #E5E5E5;
  border-radius: 6px;
  overflow: hidden;
`;

export const ProgressBar = styled.div<{ ratio: number }>`
  height: 100%;
  border-radius: 6px;
  transition: width 0.3s ease;
  width: ${props => props.ratio * 100}%;
  background: ${props => {
    if (props.ratio >= 2/3) return '#FF6B6B';
    if (props.ratio >= 1/3) return '#FFA940';
    return '#52C41A';
  }};
`;

export const InfoBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  background: #E8F5E9;
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
`;

export const InfoIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #66BB6A;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
`;

export const InfoText = styled.div`
  flex: 1;
  font-size: 13px;
  color: #2E7D32;
  line-height: 1.5;
`;

export const LoadingContainer = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
`;

export const EmptyContainer = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
`;
